import styled from 'styled-components'
import { colors } from '../../theme'

type ButtonType = 'DATA' | 'PSWD'

export const Button = styled.button<{
  buttonType: ButtonType
  marginTop?: string
}>`
  border: none;
  background-color: ${({ buttonType }) =>
    buttonType === 'DATA' ? `${colors.accentBg}` : `${colors.grey200}`};
  color: ${({ buttonType }) =>
    buttonType === 'DATA' ? `${colors.white}` : `${colors.grey700}`};
  width: 215px;
  height: 40px;
  border-radius: 8px;
  cursor: pointer;
  margin: 0 0 20px 0;
  margin-top: ${({ marginTop }) => `${marginTop}`};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  padding-left: 15px;
  font-size: 14px;
`
export const Container = styled.div`
  display: flex;
  gap: 60px;
  margin-top: 30px;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 30px;
`
export const DivData = styled.div`
  min-width: 20%;
  @media screen and (max-width: 1400px) {
    width: 40%;
  }
`

export const Span = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* gap: 170px; */
`
export const ContainerInput = styled.span`
  width: 350px;
  text-align: left;
`

export const ButtonEdit = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`

export const Input = styled.input`
  border: 1.5px solid ${colors.grey300};
  border-radius: 8px;
  font-size: 12px;
  padding: 15px;
  width: 320px;
  height: 42px;
`
export const DivInput = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 20px;
  font-size: 14px;
  font-weight: 700;

  .title {
    margin-top: 10px;
    font-size: 14px;
    font-weight: 700;
    color: ${colors.grey900};
    margin-left: 0px;
  }

  div {
    display: flex;
    flex-direction: column;
  }

  span {
    color: ${colors.errorText};
    font-size: 12px;
    margin-left: 13px;
    margin-top: 3px;
  }
`
